export default "__VITE_ASSET__Gj4VNKxI__"